import { cn } from "../../lib/utils";
import { Card, Text } from "../../primitives";
import { ExposureChart, type ExposureChartProps, ExposureTitle } from "./ExposureChart";
import type { ExposureLimitSummary } from "./types";

export type ExposureWithLimitProps = ExposureChartProps & {
	limitSummary?: ExposureLimitSummary;
	title?: string;
	updatedAtLabel?: string;
};

export const ExposureWithLimit = ({
	limitSummary,
	title = "Exposure",
	updatedAtLabel,
	testId = "exposure",
	...chart
}: ExposureWithLimitProps) => (
	<ExposureChart
		{...chart}
		testId={testId}
		headerClassName="gap-1"
		header={
			<div className="flex items-baseline justify-between gap-4">
				<ExposureTitle title={title} updatedAtLabel={updatedAtLabel} />
				<Card.Actions
					className={cn(
						"flex-col items-start gap-2.5 tabular-nums",
						limitSummary === undefined && "invisible",
					)}
					aria-hidden={limitSummary === undefined ? true : undefined}
					data-testid={`${testId}-limit`}
				>
					<Text type="eyebrow" color="tertiary">
						{limitSummary?.label ?? "\u00a0"}
					</Text>
					<Text
						type="body-strong"
						color={limitSummary?.overLimit ? "danger" : "primary"}
						className="whitespace-nowrap"
						data-testid={limitSummary === undefined ? undefined : `${testId}-limit-value`}
					>
						{limitSummary?.value ?? "\u00a0"}
					</Text>
				</Card.Actions>
			</div>
		}
	/>
);
